import { render, staticRenderFns } from "./viewUpload.vue?vue&type=template&id=31591ed5&"
import script from "./viewUpload.vue?vue&type=script&lang=js&"
export * from "./viewUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "viewUpload.vue"
export default component.exports